<div [class.container]="isVerticalLayout$ | async" class="toolbar text-default w-full px-6 flex items-center">
  <button (click)="openSidenav()" [class.hidden]="isDesktop$ | async" mat-icon-button type="button">
    <mat-icon svgIcon="mat:menu"></mat-icon>
  </button>

  <h2 class="ml-2 title">
    <span>{{ grupoRota() }} </span>
  </h2>

  @if (isVerticalLayout$ | async) {
    <a [routerLink]="['/']" class="ltr:mr-4 rtl:ml-4 flex items-center">
      <img alt="Logo" class="w-8 select-none" src="assets/img/logo/logo.svg" />
      <h1
        [class.hidden]="isDesktop$ | async"
        class="text-2xl font-bold tracking-wide ltr:pl-4 rtl:pr-4 m-0 select-none"
      >
        {{ title$ | async }}
      </h1>
    </a>
  }

  @if ((isVerticalLayout$ | async) && (isNavbarInToolbar$ | async)) {
    <div [class.hidden]="!(isDesktop$ | async)" class="px-6 flex-none flex items-center">
      @for (item of navigationItems$ | async; track item) {
        <vex-navigation-item [item]="item"></vex-navigation-item>
      }
    </div>
  }

  <span class="flex-1"></span>

  <div class="-mx-1 flex items-center">
    @if (userVisible$ | async) {
      <div class="px-1">
        <vex-toolbar-user></vex-toolbar-user>
      </div>
    }
  </div>
</div>

@if ((isVerticalLayout$ | async) && (isNavbarBelowToolbar$ | async)) {
  <vex-navigation [class.hidden]="!(isDesktop$ | async)"></vex-navigation>
}
